import React from 'react';
import { useSelector } from 'react-redux';
import { State } from 'store/onboarding';

import Slide from '@material-ui/core/Slide';
import Category from 'components/onboarding/Category';

interface Props {
  isOnHomePage?: boolean;
}

function Checklist({ isOnHomePage = false }: Props) {
  const onboardingState: State = useSelector((state: any) => state.onboarding);
  const { checkList, bubbleOpen } = onboardingState;

  const renderChildren = (children: React.ReactNode) => {
    return (
      <>
        {isOnHomePage ? (
          <div>{children}</div>
        ) : (
          <Slide direction="up" in={bubbleOpen} mountOnEnter unmountOnExit timeout={{ enter: 500 }}>
            <div>{children}</div>
          </Slide>
        )}
      </>
    );
  };

  return renderChildren(
    <>
      {checkList.map(category => (
        <Category key={category.id} category={category} isOnHomePage={isOnHomePage} />
      ))}
    </>,
  );
}

export default Checklist;
